import axios from "@/plugins/axios";
import { actionTypes, mutationTypes } from "@/store/MultiPublisherYield/types";
import { getPeriodObject } from "@/helpers/data";

export const actions = {
    [actionTypes.getData]({ commit }, { period, publisherIds, timezone, noCommit }) {
        !noCommit && commit(mutationTypes.yieldStart);

        let data = {
            publisher_ids: publisherIds,
            interval_enum: typeof period === "string" ? 1 : 2,
            time_zone: timezone || "Europe/Prague",
            interval: "1d",
            metadata: {},
        };

        if (typeof period === "string") {
            const periodObj = getPeriodObject(period);
            data["period"] = periodObj ? periodObj.type_id : period;
        } else {
            let dateFrom = new Date(period.dateFrom);
            let dateFromYYYYMMDD = dateFrom.toISOString().split("T")[0];

            let dateTo = new Date(period.dateTo);
            let dateToYYYYMMDD = dateTo.toISOString().split("T")[0];

            data["period"] = "custom_range";
            data["date_from"] = dateFromYYYYMMDD;
            data["date_to"] = dateToYYYYMMDD;
        }

        return axios({
            method: "post",
            url: "sql/yield-by-publishers",
            data: data,
        }).then(
            ({ data }) => {
                !noCommit && commit(mutationTypes.yieldSuccess, data);
                return data;
            },
            (error) => {
                console.error("[MultiPublisherYield] Error:", error);
                !noCommit && commit(mutationTypes.yieldFailure);
            }
        );
    },
};
